import { BoxProps } from '@chakra-ui/react';
import React from 'react';
import AutoSizer from 'react-virtualized/dist/es/AutoSizer';

import { CmBox } from '@/components/uiParts';

type Props = Required<Pick<BoxProps, 'height' | 'width'>>;

export const ChartContainer: React.FC<Props & BoxProps> = ({
  children,
  height = '100%',
  width = '100%',
  ...rest
}) => {
  return (
    <CmBox height={height} width={width} {...rest}>
      <AutoSizer>
        {({ height, width }) => (
          <CmBox height={height} width={width}>
            {children}
          </CmBox>
        )}
      </AutoSizer>
    </CmBox>
  );
};
